import { HFlow, Tag } from 'bold-ui'
import { useAlertasSdc } from 'hooks/sdc/useAlertasSdc'
import React from 'react'
import { CypressProps } from 'types/cypress'

export function RiscoPreEclampsiaTag({ dataTestId }: Readonly<CypressProps>) {
  const alertasSdcContext = useAlertasSdc()

  // TODO@Codebenders: substituir esta lógica pelo hook de verificação do Risco de Pré-Eclâmpsia quando disponível (issue #25073).
  const hasAlertaRiscoPreEclampsia = (alertasSdcContext?.alertasSdc ?? []).some(
    (alerta) => alerta.id === 'ALERTA_PRE_ECLAMPSIA'
  )

  return (
    <HFlow data-testid={dataTestId}>
      {hasAlertaRiscoPreEclampsia ? <Tag type='danger'>Identificado</Tag> : <Tag type='normal'>Não identificado</Tag>}
    </HFlow>
  )
}
